var chunkMapping = {
	"36": [
		9036
	],
	"585": [
		8585
	],
	"662": [
		768,
		846,
		3705,
		5448,
		6164,
		6246,
		6588
	],
	"967": [
		6967
	]
};
var idToExternalAndNameMapping = {
	"768": [
		"default",
		"./PageError",
		5918
	],
	"846": [
		"default",
		"./component-auth",
		9794
	],
	"3705": [
		"default",
		"./useAnalytics",
		9794
	],
	"5448": [
		"default",
		"./BulkActionBar",
		5918
	],
	"6164": [
		"default",
		"./react-query",
		9794
	],
	"6246": [
		"default",
		"./httpRequest",
		4718
	],
	"6588": [
		"default",
		"./VeGrid",
		5918
	],
	"6967": [
		"default",
		"./component-logging",
		9794
	],
	"8585": [
		"default",
		"./BaseViewLayout",
		5918
	],
	"9036": [
		"default",
		"./ApplicationWrapper",
		5918
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}